// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container-GspQK {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.main-body-x0TTw {
  display: flex;
  flex-grow: 1;
  overflow: hidden;
}

.main-navBar_container-bTFgQ {
  height: 100%;
  width: 64px;
  flex-shrink: 0;
}

.main-content-Rtz4Q {
  height: 100%;
  flex: 1;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/pages/main/main.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,gBAAgB;AAClB","sourcesContent":[".container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.body {\n  display: flex;\n  flex-grow: 1;\n  overflow: hidden;\n}\n\n.navBar_container {\n  height: 100%;\n  width: 64px;\n  flex-shrink: 0;\n}\n\n.content {\n  height: 100%;\n  flex: 1;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `main-container-GspQK`,
	"body": `main-body-x0TTw`,
	"navBar_container": `main-navBar_container-bTFgQ`,
	"content": `main-content-Rtz4Q`
};
export default ___CSS_LOADER_EXPORT___;
